import { EStudentImportAttributeFieldNames } from 'types';
import { importStudentFields } from '../importStudentFields/index.js';

const tuitionKey = EStudentImportAttributeFieldNames.TUITION_DEPOSIT;
const tuitionFieldName = importStudentFields[tuitionKey].name; // tuitition deposit is shown as depositAmount

export type OfficeSelectionValue = typeof tuitionFieldName | EStudentImportAttributeFieldNames;

export interface IOfficeSelection {
  label: string;
  summaryField: string | null;
  value: OfficeSelectionValue;
}

/**
 * Array used to list office selection fields in the uni configuration app.
 * Used to configure additional conditions for offices to view students by.
 */
export const officeSelectionFields: IOfficeSelection[] = Object.entries(importStudentFields).map(
  ([fieldName, field]) => {
    return {
      label: field.label,
      summaryField: field.summaryField,
      value: (fieldName === tuitionKey ? tuitionFieldName || '' : fieldName) as OfficeSelectionValue,
    };
  },
);
